import { Box, Grid } from "@mui/material";
import { SubGroupFilterItem } from "pages/TargetV2/types/targetV2.types";
import React, { FC, useState, useCallback } from "react";
import "../pastInteraction/PastInteractionSubGroupContainer.scss";
import CancelIcon from "@mui/icons-material/Cancel";
import { useTargetV2Context } from "pages/TargetV2/context/targetV2.context";
import "../SubGroupFilterCustom.scss";
import OperatorLine from "../../components/operatorLine/OperatorLine";
import SelectOperatorDropDown from "../../components/selectOperatorDropDown/SelectOperatorDropDown";
import SimpleDateRange from "../../filterRow/dateRange/SimpleDateRange";
import SubGroupFilterItemsContainer from "../../SubGroupFilterItemsContainer";
import CallFilterRow from "../../filterRow/call/CallFilterRow";

type CallContainerProps = {
  parentFilterItem: SubGroupFilterItem;
  subGroupFilterItem: SubGroupFilterItem;
  index: number;
  level: number;
  snapchot: any;
};

const CallContainer: FC<CallContainerProps> = ({
  parentFilterItem,
  subGroupFilterItem,
  index,
  level,
  snapchot,
}) => {
  const { handleDeleteSubGroupFilterItem, isApplyingFilters } =
    useTargetV2Context();
  return (
    <>
      <Grid className="sub-group-custom-wrapper" key={index}>
        <Box display="flex" justifyContent="space-between" marginTop="8px">
          <Box display="flex" alignItems="center" gap="22px">
            <Box className="past-interaction-title-wrapper">
              <Box className="past-interaction-title">
                {subGroupFilterItem.name}
              </Box>
            </Box>
          </Box>
          <CancelIcon
            onClick={() =>
              handleDeleteSubGroupFilterItem(subGroupFilterItem.parentId, index)
            }
            cursor="pointer"
            className="cancel-icon"
          />
        </Box>

        <Box>
          {subGroupFilterItem.filterItemsChildren.length > 0 && (
            <SimpleDateRange
              key={subGroupFilterItem.filterItemsChildren[0].filterId}
              filterItem={subGroupFilterItem.filterItemsChildren[0]}
              id={subGroupFilterItem.subGroupId}
              index={index}
              groupType={subGroupFilterItem.groupType}
            />
          )}
        </Box>

        {subGroupFilterItem.subgGroupFilterItemsChildren?.length > 0 &&
          subGroupFilterItem.subgGroupFilterItemsChildren.map(
            (subGroup, indexVal) => (
              <Box
                className="first-subgroup-container"
                key={subGroup.subGroupId || `subgroup-${indexVal}`}
              >
                <Box
                  display="flex"
                  flexWrap="wrap"
                  flexDirection="column"
                  justifyContent="space-between"
                  maxWidth="100%"
                  marginTop="22px"
                  key={indexVal}
                >
                  {subGroup.filterItemsChildren.length > 0 &&
                    subGroup.filterItemsChildren.map((filterItem, index) => (
                      <Box key={filterItem.filterId} position="relative">
                        <CallFilterRow
                          key={filterItem.filterId}
                          filterItem={filterItem}
                          index={index}
                          name={filterItem.name}
                          filters={filterItem.filters}
                          filtersSelected={filterItem.filtersSelected}
                          id={subGroup.subGroupId}
                          level={level}
                          isMandatory={filterItem.isMandatory}
                          snapchot={snapchot}
                          isResponsive={filterItem.isResponsive}
                          parentItem={subGroupFilterItem}
                        />
                        {/* </Box> */}
                        {/* {isApplyingFilters && filterItem.countHCPS !== null && (
                          <Box
                            style={{
                              position: "absolute",
                             right: -108 - (level - 1) * 52,
                             marginTop:-55,
                            }}
                          >
                            <Box className="count-hcps-wrapper">
                              <Box className="count-hcps-number">
                                {filterItem.countHCPS} HCPS
                              </Box>
                            </Box>
                          </Box>
                        )} */}
                        {index < subGroup.filterItemsChildren.length - 1 && (
                          <Box marginLeft="34px">
                            <OperatorLine
                              operator={subGroupFilterItem.operator}
                              width="84%"
                            />
                          </Box>
                        )}

                        {isApplyingFilters &&
                          filterItem?.countHCPS !== null && (
                            <Box
                              style={{
                                position: "absolute",
                                right: level <= 1 ? -158 : -176,
                                bottom:
                                  index <
                                  subGroupFilterItem.filterItemsChildren
                                    .length -
                                    1
                                    ? 60
                                    : 26,
                              }}
                            >
                              <Box className="count-hcps-wrapper">
                                <Box className="count-hcps-number">
                                  {filterItem.countHCPS} HCPS
                                </Box>
                              </Box>
                            </Box>
                          )}
                      </Box>
                    ))}
                  {subGroup.subgGroupFilterItemsChildren.length > 0 && (
                    <>
                      <Box marginLeft="34px">
                        <OperatorLine
                          operator={subGroup.operator}
                          width="84%"
                        />
                      </Box>
                      <div style={{ marginTop: "16px" }}>
                        {subGroup.subgGroupFilterItemsChildren.map(
                          (subGroupFilterItemChildren, childIndex) => (
                            <React.Fragment
                              key={
                                subGroupFilterItemChildren.subGroupId ||
                                `subgroup-child-${indexVal}-${childIndex}`
                              }
                            >
                              {childIndex > 0 && (
                                <Box marginLeft="34px">
                                  <OperatorLine
                                    operator={subGroup.operator}
                                    width="84%"
                                  />
                                </Box>
                              )}
                              <div
                                key={childIndex}
                                style={{ position: "relative" }}
                              >
                                <SubGroupFilterItemsContainer
                                  subGroupFilterItem={
                                    subGroupFilterItemChildren
                                  }
                                  level={level + 1}
                                  index={index}
                                  groupType={"CALL"}
                                />
                              </div>
                            </React.Fragment>
                          )
                        )}
                      </div>
                    </>
                  )}
                </Box>
              </Box>
            )
          )}
      </Grid>
    </>
  );
};

export default CallContainer;
